import io from "socket.io-client";

export const RESYNC_EVENT = "app:resync";
const HIDDEN_RESYNC_MS = 60 * 1000;

let resyncTimer = null;
// Eventos do socket perdidos durante queda ou aba congelada não são reenviados;
// as telas escutam este evento para recarregar o que pode ter mudado.
const requestResync = () => {
  clearTimeout(resyncTimer);
  resyncTimer = setTimeout(() => window.dispatchEvent(new Event(RESYNC_EVENT)), 300);
};

let hiddenAt = null;
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") {
    hiddenAt = Date.now();
    return;
  }
  const wasHiddenLong = hiddenAt && Date.now() - hiddenAt > HIDDEN_RESYNC_MS;
  hiddenAt = null;

  const socket = SocketWorker.instance?.socket;
  if (socket && !socket.connected) {
    socket.connect();
    return;
  }
  if (wasHiddenLong) requestResync();
});

class SocketWorker {
  constructor(companyId, userId) {
    if (!SocketWorker.instance) {
      this.companyId = companyId;
      this.userId = userId;
      this.socket = null;
      this.eventListeners = {};
      this.configureSocket();
      SocketWorker.instance = this;
    }

    return SocketWorker.instance;
  }

  configureSocket() {
    // Lê o token do localStorage a cada nova conexão para sempre usar o mais recente
    const rawToken = localStorage.getItem("token");
    const token = rawToken ? `Bearer ${JSON.parse(rawToken)}` : "";

    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this.companyId}`, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      transports: ["websocket", "polling"],
      // auth como função: avaliada a cada tentativa de reconexão com token fresco
      auth: (cb) => {
        const raw = localStorage.getItem("token");
        cb({ token: raw ? `Bearer ${JSON.parse(raw)}` : "" });
      },
      query: { userId: this.userId, token },
    });

    let hadDisconnect = false;
    this.socket.on("disconnect", () => {
      hadDisconnect = true;
    });

    this.socket.on("connect", () => {
      console.log("Socket.IO conectado");
      if (hadDisconnect) {
        hadDisconnect = false;
        requestResync();
      }
    });

    // Não sobrescrever a reconexão nativa do Socket.IO — ela preserva todos os listeners
    // e re-emite o evento "connect" que os componentes usam para re-entrar nos rooms
  }

  on(event, callback) {
    this.connect();
    this.socket.on(event, callback);

    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  off(event, callback) {
    this.connect();
    if (this.eventListeners[event]) {
      if (callback) {
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      SocketWorker.instance = null; // limpa o singleton para próxima conexão ser fresca
      console.log("Socket desconectado manualmente");
    }
  }

  connect() {
    if (!this.socket) {
      this.configureSocket();
      // Re-registra listeners salvos no novo socket (caso chamado após disconnect() manual)
      Object.entries(this.eventListeners).forEach(([event, callbacks]) => {
        callbacks.forEach(cb => this.socket.on(event, cb));
      });
    }
  }

  forceReconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.connect();
    }
  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;